import { useInterval } from 'app/services';
import moment from 'moment';
import React, { useState } from 'react';
const MapTransportConditionTimer = ({ lastTime }) => {
    const [currentTime, setCurrentTime] = useState(moment());
    useInterval(() => {
        setCurrentTime(moment());
    }, 1000);
    const time = moment.utc(currentTime.diff(moment(lastTime)));
    return React.createElement(React.Fragment, null, time.valueOf() > 0 ? time.format('HH:mm:ss') : '00:00:00');
};
export default MapTransportConditionTimer;
